import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { StandardSnack } from '@sketch-note/design-system/src/components/snackbar';
import { Button, DropdownTwo, LoaderSm } from '@sketchnote/shared-components';
import * as React from 'react';

import { useSettings } from './store';
import { useAvailabilityStore } from './store/useAvailabilityStore';
const { useState } = React;

export const Availability = ({ onClose }: { onClose: () => void }): JSX.Element => {
  const { hours } = useAvailabilityStore((state) => state);
  const [loaderIsOpen, setLoaderIsOpen] = useState(false);
  const [snackbarModalIsOpen, setSnackbarModalIsOpen] = useState(false);
  const [userHours, setUserHours] = useState<number>(hours);
  const [callbacks] = useSettings();

  const handleSaveChanges = async () => {
    setLoaderIsOpen(true);

    const response = await callbacks?.onUpdateAvailability?.({
      hours: userHours,
    });

    if (response.isSuccess) {
      setLoaderIsOpen(false);
      setSnackbarModalIsOpen(true);
      setTimeout(function () {
        setSnackbarModalIsOpen(false);
      }, 1500);
    }
  };

  const handleLoaderModal = () => {
    setLoaderIsOpen(false);
  };

  const handleSnackbarModal = () => {
    setSnackbarModalIsOpen(false);
  };

  const dropDownOptions = [
    { value: '1', label: '1 Hour' },
    { value: '2', label: '2 Hours' },
    { value: '3', label: '3 Hours' },
    { value: '4', label: '4 Hours' },
    { value: '5', label: '5 Hours' },
    { value: '6', label: '6 Hours' },
    { value: '7', label: '7 Hours' },
    { value: '8', label: '8 Hours' },
    { value: '9', label: '9 Hours' },
    { value: '10', label: '10 Hours' },
    { value: '11', label: '11 Hours' },
    { value: '12', label: '12 Hours' },
  ];

  const handleHourChange = (v) => {
    setUserHours(Number(v.value));
  };

  return (
    <div>
      <div className="overflow-y-auto px-48 " style={{ height: '53rem' }}>
        <section className="pb-32 pt-16">
          <span className="block font-medium text-base text-gray-999 mb-6">Work hours</span>
          <p className="text-sm text-gray-600 mb-32">
            Set the standard number of hours put in for each working day.
            <br />
            Your daily capacity will be calculated based on this number.
          </p>
          <div className="mb-10">
            <DropdownTwo
              className=" desktop:w-332 laptop:w-332 tablet:w-full mobile:w-full bg-gray-100  rounded mb-32"
              placeholder={'Select an option'}
              value={dropDownOptions.find((i) => i.value === userHours.toString())}
              options={dropDownOptions}
              onChange={handleHourChange}
            />
          </div>
        </section>
      </div>
      <div className="sticky flex justify-end px-64 py-12 border-t border-gray-200 ">
        <Button status="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button status="primary" className="ml-10" onClick={handleSaveChanges}>
          Save changes
        </Button>
      </div>

      <Modal isOpen={loaderIsOpen} onClose={handleLoaderModal}>
        <ModalOverlay />
        <ModalContent style={{ width: '38.4rem', padding: '30px', marginTop: '20rem' }}>
          <p className="font-semibold mb-20"> We&apos;re saving your changes </p>
          <LoaderSm className="mx-auto text-xss" />
        </ModalContent>
      </Modal>

      <Modal isOpen={snackbarModalIsOpen} onClose={handleSnackbarModal}>
        <ModalContent style={{ width: '180px', borderRadius: '10px', marginTop: '65rem' }}>
          <StandardSnack text="Changes Saved" />
        </ModalContent>
      </Modal>
    </div>
  );
};
